export const CORRECTIONAL_PROCEDURE_ID = 3;
export const NOTIFICATION_TYPE = {
  EXPEERTISE_REJECTION: 'EXPEERTISE_REJECTION',
};
export const OPENING_INBOXES = 'Ouverture';
export const CICA_MIXTE_INBOXES = 'Conversion mixte - cica';
export const OPENING_CORPOR_INBOXES = 'Ouverture corporelle';
export const BIN_INVOICE_TITLE = 'Facture';

export const LAWYER_INBOXES_TITLES = {
  FIRM_REFERENCE: 'Référence Cabinet',
  CONTESTATION_APPEAL: 'Contestation / Voie de recours',
  INVOICE: 'Facture',
  PROVISIONAL_CLAIM: 'Dossiers Provisoires',
};
